import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import CreateMemorial from "@/pages/CreateMemorial";
import ViewMemorial from "@/pages/ViewMemorial";
import Gallery from "@/pages/Gallery";
import CreateEcard from "@/pages/CreateEcard";
import ViewEcard from "@/pages/ViewEcard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import KeepsakeCards from "@/pages/KeepsakeCards";
import Commission from "@/pages/Commission";
import CommissionThanks from "@/pages/CommissionThanks";
import About from "@/pages/About";
import MemorialEmbed from "@/pages/MemorialEmbed";
import ReturnPolicy from "@/pages/ReturnPolicy";
import PayPalReturn from "@/pages/PayPalReturn";
import MemorialUpgrade from "@/pages/MemorialUpgrade";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function RequireAdmin({ children }) {
  const token = localStorage.getItem("rb_admin_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

function Layout({ children, hideNav }) {
  return (
    <>
      {!hideNav && <Nav />}
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" toastOptions={{ style: { background: "rgba(255,255,255,0.95)", border: "1px solid rgba(212,175,55,0.3)", color: "#2C2825", fontFamily: "Outfit, sans-serif" } }} />
        <Routes>
          <Route path="/" element={<Layout><Landing /></Layout>} />
          <Route path="/create" element={<Layout><CreateMemorial /></Layout>} />
          <Route path="/memorial/:slug" element={<Layout><ViewMemorial /></Layout>} />
          <Route path="/memorial/:slug/upgrade" element={<Layout><MemorialUpgrade /></Layout>} />
          <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
          <Route path="/ecard" element={<Layout><CreateEcard /></Layout>} />
          <Route path="/ecard/:slug" element={<Layout><ViewEcard /></Layout>} />
          <Route path="/commission" element={<Layout><Commission /></Layout>} />
          <Route path="/commission/thanks" element={<Layout><CommissionThanks /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/return-policy" element={<Layout><ReturnPolicy /></Layout>} />
          <Route path="/paypal/return" element={<Layout><PayPalReturn /></Layout>} />
          <Route path="/embed/memorial/:slug" element={<MemorialEmbed />} />
          <Route path="/admin/login" element={<Layout><AdminLogin /></Layout>} />
          <Route path="/admin" element={<RequireAdmin><Layout><AdminDashboard /></Layout></RequireAdmin>} />
          <Route path="/admin/keepsake-cards" element={<RequireAdmin><KeepsakeCards /></RequireAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
